import React from 'react';
import { translate } from '../utils/translator';
import { CANNABIS_SERVICE_FEE_TEST, SERVICE_FEE_TEST_VARIANT } from '../utils/consts';

type Props = {
  variant: string | null | undefined;
  flowerCount: number;
  nonFlowerPresent: boolean;
  language: string | undefined;
  id: string;
  className?: string;
  as?: 'div' | 'span';
}

const ServiceFeeTestHelper: React.FC<Props> = ({ variant, flowerCount, nonFlowerPresent, language, id, className, as: Tag = 'div' }) => {
  const isTestVariant = variant === SERVICE_FEE_TEST_VARIANT.TEST || variant === SERVICE_FEE_TEST_VARIANT.C;
  if (!isTestVariant || nonFlowerPresent || flowerCount <= 1) return null;

  const clampedCount = Math.min(flowerCount, CANNABIS_SERVICE_FEE_TEST.MAX_FLOWERS);
  const feeMap = variant === SERVICE_FEE_TEST_VARIANT.C
    ? CANNABIS_SERVICE_FEE_TEST.FLOWER_FEE_BY_COUNT_C
    : CANNABIS_SERVICE_FEE_TEST.FLOWER_FEE_BY_COUNT;
  const extraEuros = feeMap[clampedCount] - feeMap[1];

  if (!extraEuros) return null;

  return (
    <Tag id={id} className={className}>
      {`Nur +${extraEuros}€ ${translate(language, 'default', 'OrderWindow/service_fee_test_extra_item')}`}
    </Tag>
  );
};

export default ServiceFeeTestHelper;
